/** React */
import { useLocation } from "react-router";

/** Components */
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
    const location = useLocation();

    return (
        <>
            <Header type={location.pathname === "/in" || location.pathname === "/out" ? "notMain" : ""} />
                <main>{children}</main>
            <Footer />
        </>
    );
};

export default Layout;
